<template>
  <i :class="classes" :style="stylesIcon"></i>
</template>
<script>
import { PREFIX_ICON_CLASS } from '@/utils/constants'
const prefixCls = PREFIX_ICON_CLASS.replace('-', '')
export default {
  name: 'TIcon',
  props: {
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: [ Number, String ],
      default: ''
    },
    shape: {
      // 自定义验证函数进行props验证
      type: String,
      validator (value) {
        return [ 'circle', 'rectangle', '' ].includes(value)
      },
      default: ''
    },
    bgColor: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      validator (value) {
        return [ 'primary', 'success', 'info', 'warning', 'danger', '' ].includes(value)
      },
      default: ''
    },
    rotate: {
      type: String,
      validator (value) {
        return [ '90', '180', '270', '' ].includes(value)
      },
      default: ''
    }
  },
  computed: {
    classes () {
      return [
        `${prefixCls}`,
        `${prefixCls}-${this.icon}`,
        {
          [`text-${this.color}`]: !!this.color,
          [`rotate-${this.rotate}`]: !!this.rotate,
          [`icon-bg--${this.shape}`]: !!this.shape,
          [`bg-${this.bgColor}`]: !!this.bgColor
        }
      ]
    },
    stylesIcon () {
      let style = {}
      if (this.size) {
        style[ 'font-size' ] = `${this.size}px`
      }
      return style
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/icon/icon.vue